// extracted by mini-css-extract-plugin
export default {"card2":"sOaCXyc6","image":"nlzAZejx","headline":"r1CO9RPx"};